import React from "react";
import * as AboutS from "./styles/aboutS";
import Bio from "../components/aboutSection/bio/Bio";

const About = () => {
  return (
    <>
      <AboutS.Wrapper />
      <Bio />
    </>
  );
};

export default About;
